module.exports = __webpack_public_path__ + "img/u47.5c901832.png";